import WhereToStart from "@/components/pages/Community/WhereToStart/WhereToStart";

export default WhereToStart;
